import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATEGORIES = [
  { key: "expression", label: "Disrespect & Dismissal" },
  { key: "behavior_nonviolent", label: "Unfair Treatment" },
];

export function ScenarioCategorySelect({ value, onChange }) {
  return (
    <div>
      <Label className="text-zinc-500 text-xs uppercase tracking-wide mb-2 block">Category</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="admin-scenario-category-select" className="bg-white border-zinc-300 text-zinc-950 rounded-none focus:ring-1 focus:ring-[#4FD1C5]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-white border-zinc-200">
          {CATEGORIES.map((c) => (
            <SelectItem key={c.key} value={c.key} data-testid={`admin-scenario-category-option-${c.key}`}>{c.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
